import React from 'react';
import { array, string } from 'prop-types';
import { intlShape } from 'react-intl';
import classNames from 'classnames';
import { includes, map } from 'ramda';

import ExtraItem from './ExtraItem/ExtraItem';
import css from './SectionExtras.module.css';

const SectionExtras = (props) => {
  const {
    className,
    intl,
    paidExtrasData,
    titleClassName,
    selectedExtras = [],
  } = props;
  const titleText = intl.formatMessage({ id: 'ListingPage.SectionExtras.title' });
  const addExtraCta = intl.formatMessage({ id: 'ListingPage.SectionExtras.addExtra' });
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      <div className={css.extraList}>
        {map((extraData) => {
          return (
            <ExtraItem
              key={extraData.id}
              isSelected={includes(extraData.id, selectedExtras)}
              className={css.extraItem}
              extraData={extraData}
              intl={intl}
            />
          )
        }, paidExtrasData)}
        <div className={css.addExtraCTA}>{addExtraCta}</div>
      </div>
    </div>
  )
}

SectionExtras.defaultProps = {
  className: null,
  titleClassName: null,
};

SectionExtras.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  paidExtrasData: array.isRequired,
  titleClassName: string,
};

export default SectionExtras;
